import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { StrictMode, useState, useEffect } from "react";
import { createRoot } from "react-dom/client";
import { BrowserRouter } from "react-router-dom";
import { Routes } from "./routes";
import vineCorner from "./assets/images/vine-corner.png";
import bottomGrass from "./assets/images/bottom-grass.png";
import sunImg from "./assets/images/sun.png";
import moonImg from "./assets/images/moon.png";
import "./app.scss";
/** Check if current time is during dark hours (7 PM - 7 AM) */
function isDarkHours() {
    const hour = new Date().getHours();
    return hour >= 19 || hour < 7;
}
function App() {
    const [vineSwung, setVineSwung] = useState(false);
    const [darkMode, setDarkMode] = useState(isDarkHours);
    // Sync dark mode class with state
    useEffect(() => {
        if (darkMode) {
            document.documentElement.classList.add("th_dark-mode");
        }
        else {
            document.documentElement.classList.remove("th_dark-mode");
        }
    }, [darkMode]);
    useEffect(() => {
        const handleMouseMove = (e) => {
            const distanceFromLeft = e.clientX;
            const distanceFromTop = e.clientY;
            const isNearCorner = distanceFromLeft < 100 && distanceFromTop < 100;
            setVineSwung(isNearCorner);
        };
        window.addEventListener("mousemove", handleMouseMove);
        return () => window.removeEventListener("mousemove", handleMouseMove);
    }, []);
    const toggleDarkMode = () => setDarkMode((prev) => !prev);
    return (_jsxs(BrowserRouter, { children: [_jsxs("button", { className: "th_theme-toggle", onClick: toggleDarkMode, "aria-label": darkMode ? "Switch to light mode" : "Switch to dark mode", children: [_jsx("img", { src: sunImg, alt: "", className: "th_theme-toggle__sun" }), _jsx("img", { src: moonImg, alt: "", className: "th_theme-toggle__moon" })] }), _jsx("div", { className: "th_bottom-grass", style: { "--grass-url": `url(${bottomGrass})` } }), _jsx(Routes, {})] }));
}
const root = createRoot(document.getElementById("root"));
root.render(_jsx(StrictMode, { children: _jsx(App, {}) }));
